import React, { useEffect, useState } from 'react';
import { Button, Dropdown, Input } from '@/components';
import { useBiCustomer } from '@/context/biCustomerContext/BiCustomerContextProvider';

const CreateBiCustomer = ({ closeModal, user }) => {
  const { biCustomer, setBiCustomer, updateCustomer, getAllSalesReps } =
    useBiCustomer();
  const [error, setError] = useState();
  const [salesRepOptions, setSalesRepOptions] = useState([]);

  useEffect(() => {
    if (user) {
      setBiCustomer(user);
    }
    getAllSalesReps().then((response) => {
      const options = response.map((rep) => ({
        label: rep,
        value: rep,
        data: rep,
      }));
      setSalesRepOptions(options);
    });
  }, [user]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setBiCustomer((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = validateBiCustomer();
    if (errors) {
      setError(errors);
      return;
    }
    updateCustomer(biCustomer.id, biCustomer);
    closeModal();
  };

  const validateBiCustomer = () => {
    const errors = {};
    if (!biCustomer.account) {
      errors.account = 'Account is required.';
    }
    if (!biCustomer.accountName) {
      errors.accountName = 'Account Name is required.';
    }
    if (!biCustomer.rep) {
      errors.rep = 'Rep is required.';
    }
    if (biCustomer.isNewAccount === undefined) {
      errors.isNewAccount = 'Is New Account is required.';
    }
    return Object.keys(errors).length > 0 ? errors : null;
  };

  return (
    <form>
      <div className="lg:grid grid-cols-2 gap-5 items-center lg:w-[600px]">
        <div>
          <Input
            name="account"
            type="text"
            label="Account"
            placeholder="Enter Account Code"
            value={biCustomer?.account}
            onChange={handleInputChange}
            disabled
            error={error?.account}
            required></Input>
        </div>
        <div>
          <Input label="Created Date" value={biCustomer.createdDate} disabled />
        </div>
        <div>
          <Input
            name="accountName"
            type="text"
            label="Account Name"
            placeholder="Enter Account Name"
            value={biCustomer.accountName}
            onChange={handleInputChange}
            error={error?.accountName}
            required></Input>
        </div>
        <div>
          <Dropdown
            required
            name="rep"
            label="Rep"
            options={salesRepOptions}
            value={biCustomer.rep}
            error={error?.rep}
            onChange={handleInputChange}
          />
        </div>
        <div>
          <Dropdown
            required
            name="isNewAccount"
            label="Is New Account"
            options={[
              { label: 'Yes', value: true },
              { label: 'No', value: false },
            ]}
            onChange={(e) => {
              const selectedValue = e.target.value === 'true'; // Convert string to boolean
              setBiCustomer((prev) => ({
                ...prev,
                isNewAccount: selectedValue,
              }));
            }}
            value={
              biCustomer.isNewAccount !== undefined
                ? biCustomer.isNewAccount.toString()
                : ''
            }
            error={error?.isNewAccount}
          />
        </div>
        <div>
          <Input
            name="industrySub"
            label="Industry Sub"
            type="text"
            placeholder="Enter Industry Sub"
            value={biCustomer.industrySub}
            onChange={handleInputChange}
          />
        </div>
        <div>
          <Input
            name="businessCode"
            label="Business Code"
            type="text"
            placeholder="Enter Business Code"
            value={biCustomer.businessCode}
            onChange={handleInputChange}
          />
        </div>
      </div>
      <div className="flex justify-start gap-2 mt-10 m-2">
        <Button type="button" className="secondary" onClick={closeModal}>
          Cancel
        </Button>
        <Button
          type="submit"
          className="px-4 py-2 bg-yellow-500 text-white rounded-3xl"
          onClick={handleSubmit}>
          {user ? 'Update' : 'Save'}
        </Button>
      </div>
    </form>
  );
};

export default CreateBiCustomer;
